import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin-bottom: 0px;

  @media (min-width: 768px) {
    margin-bottom: 0px;
  }
`
